var map = {
	"./about icon.png": 54148,
	"./bg_m-DZarrOoR.svg": 10015,
	"./contact icon.png": 22973,
	"./crash.png": 31389,
	"./crypto.png": 10193,
	"./default.jpg": 83107,
	"./esports.png": 29648,
	"./fishing.png": 60170,
	"./fishing_icon.png": 71108,
	"./game_icon.png": 22306,
	"./gold-coin.svg": 54636,
	"./gold_btn.png": 41325,
	"./home icon.png": 97716,
	"./livecasino.png": 30965,
	"./logo.png": 52171,
	"./lottery.png": 34415,
	"./partner icon.png": 93415,
	"./poker.png": 87855,
	"./roulette.png": 20746,
	"./slot_icon.png": 71220,
	"./slots.png": 33115,
	"./sports.png": 83359,
	"./sw1.1.png": 68664,
	"./sw1.10.png": 65002,
	"./sw1.11.png": 15763,
	"./sw1.12.png": 41272,
	"./sw1.2.png": 64275,
	"./sw1.3.png": 48714,
	"./sw1.4.png": 19141,
	"./sw1.5.png": 66876,
	"./sw1.6.png": 90807,
	"./sw1.7.png": 91310,
	"./sw1.8.png": 80697,
	"./sw1.9.png": 74448,
	"./语言.png": 59517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47412;